import { render, staticRenderFns } from "./ContatoModalManage.vue?vue&type=template&id=7dd53715&scoped=true"
import script from "./ContatoModalManage.vue?vue&type=script&lang=js"
export * from "./ContatoModalManage.vue?vue&type=script&lang=js"
import style0 from "./ContatoModalManage.vue?vue&type=style&index=0&id=7dd53715&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd53715",
  null
  
)

export default component.exports